<script setup lang="ts">
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '~/constants/website'

useDefaultMeta({
  title: 'Aplikasi Mobile | KiriminAja',
  description:
    'Satu aplikasi untuk kirim barang, cek ongkir, buat resi, lacak kiriman, dan cairkan COD lebih cepat.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apakah aplikasi KiriminAja gratis digunakan?',
    answer:
      'Ya, aplikasi KiriminAja bisa kamu download dan pakai <b>gratis tanpa biaya bulanan</b>. Kamu hanya membayar ongkir sesuai ekspedisi yang kamu pilih.'
  },
  {
    question: 'Ekspedisi apa saja yang tersedia di aplikasi ini?',
    answer:
      'KiriminAja terhubung dengan <b>puluhan ekspedisi nasional</b>, seperti JNE, J&T Express, Sicepat, Ninja, TIKI, Pos Indonesia, Paxel, GrabExpress, Gojek, dan lainnya.'
  },
  {
    question: 'Apakah bisa menggunakan fitur COD?',
    answer:
      'Tentu bisa! Kamu bisa kirim paket <b>dengan metode COD langsung dari aplikasi</b>, tanpa harus lewat marketplace.'
  },
  {
    question: 'Berapa lama dana COD cair?',
    answer:
      'Dana COD bisa <b>cair cepat tanpa pending</b>. Cashflow bisnismu lebih stabil dan bisa untuk scale up!'
  },
  {
    question: 'Apakah data pengiriman saya aman?',
    answer:
      'Pastinya aman. Semua data pengguna dan transaksi dijaga dengan sistem keamanan terenkripsi, dan KiriminAja punya <b>Control Tower System</b> untuk memantau setiap pengiriman secara real-time.'
  }
]

const schema = {
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  name: 'KiriminAja Mobile App',
  operatingSystem: 'ANDROID',
  applicationCategory: 'BusinessApplication',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: 4.2,
    ratingCount: 10135
  },
  offers: {
    '@type': 'Offer',
    price: 0
  }
}

useHead({
  script: [
    {
      key: 'ld-software-application-android',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schema)
    }
  ]
})
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Kemudahan kirim paket melalui smartphone"
      sub-title="Aplikasi COD"
      description="Satu aplikasi untuk kirim paket dengan banyak pilihan ekspedisi, dapat melacak pengiriman paket secara realtime dan bisa kirim paket COD, semua dapat dilakukan melalui smartphone anda."
      hero-image="/images/aplikasi-mobile-banner-1.webp"
    >
      <template #action>
        <div class="flex gap-4 flex-wrap">
          <NuxtLink
            :to="$utm.utmUrl(GOOGLE_PLAY_URL, undefined, true)"
            rel="noopener noreferrer"
            class="inline-block"
          >
            <NuxtImg
              alt="playstore"
              width="177px"
              height="52px"
              src="/images/home-v4/playstore.webp"
              class="max-w-full max-h-[3.25rem]"
            />
          </NuxtLink>
          <NuxtLink
            :to="$utm.utmUrl(APP_STORE_URL)"
            rel="noopener noreferrer"
            class="inline-block"
          >
            <NuxtImg
              alt="appstore"
              width="177px"
              height="52px"
              src="/images/home-v4/appstore.webp"
              class="max-w-full max-h-[3.25rem]"
            />
          </NuxtLink>
        </div>
      </template>
    </HeroBase>

    <SolusiAplikasiMobileSection1 />
    <SolusiAplikasiMobileSection4 />
    <SolusiAplikasiMobileSection2 />
    <SolusiAplikasiMobileSection3 />
    <FaqBase :faqs="faqs" />
    <SolusiAplikasiMobileCta />
  </div>
</template>
